import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Logo from "../../../assets/logosz.png";
import reqEMail from "../../../services/reqEMail/reqEMail";
import { BtnSubmit } from "../../button/button-submit/button-submit";
import reqColaborador from "../../../services/reqMultiTenant/reqColaborador";
import { ToastContainer } from "react-toastify";
import { handleMessageError, handleMessageSuccess } from "../../toast";

const PasswordRecovery = () => {
	const {
		register,
		handleSubmit,
		watch,

		formState: { errors, isSubmitting },
	} = useForm();

	const [loading, setLoading] = useState(false);
	const [emailToConfirm, setEmailToConfirm] = useState("");
	const [showModal, setShowModal] = useState(false);
	const [mensagemDeErro, setMensagemDeErro] = useState("");
	const [isEmaiSent, setIsEmailSent] = useState(false); //email enviado com sucesso

	const onSubmit = (data) => {
		setEmailToConfirm(data.email); // Guarda o email digitado
		setShowModal(true); // Exibe o modal de confirmação
	};

	const confirmEmail = async () => {
		try {
			setLoading(true);
			setMensagemDeErro("");
			setIsEmailSent(false);
			setShowModal(false);
			const body = {
				email_destino: emailToConfirm,
				assunto: "Redefenir senha",
				mensagem: "",
			};
			const response = await reqEMail.sendEMail(body);

			if (response.status === 200) {
				setIsEmailSent(true);
			}
		} catch (error) {
			handleMessageError("Erro ao enviar e-mail para redefinir senha");
			setLoading(false);
			setMensagemDeErro(error.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="flex flex-col justify-center items-center w-full text-center p-5">
			<ToastContainer />
			<form className="w-full max-w-md" onSubmit={handleSubmit(onSubmit)}>
				<div className="flex justify-center mb-3">
					<img className="mt-3" src={Logo} alt="SZ Delivery" />
				</div>
				<h3 className=" text-2xl mb-4">Redefinir Senha</h3>
				<p className="flex justify-start text-sm mb-1">Confirme seu E-mail</p>

				{/* Campo de Email */}
				<div className="form-floating mb-3">
					<input
						type="email"
						{...register("email", { required: "Email é obrigatório" })}
						className="form-control"
						id="floatingInput"
						placeholder="name@exemplo.com"
					/>
					<label htmlFor="floatingInput" className="text-slate-500">
						E-mail
					</label>
					{errors.email && <p className="text-red-500 text-sm">{errors.email.message}</p>}
				</div>

				<button type="submit" className={`w-full btn btn-primary mb-3`} disabled={loading}>
					{!loading ? "Confirmar E-mail" : "Enviando"}
					{loading && (
						<>
							<span
								className="spinner-grow custom-spinner spinner-grow-sm text-color me-2 ms-2"
								role="status"
							></span>
							<span
								className="spinner-grow custom-spinner spinner-grow-sm text-color me-2"
								role="status"
							></span>
						</>
					)}
				</button>
				{isEmaiSent && (
					<div className="flex justify-center items-center bg-green-100 border border-green-400 text-green-700 rounded p-2 mb-3">
						<p className="text-green-900 text-sm">{`E-mail enviado com sucesso. Verifique sua caixa de entrada.`}</p>
					</div>
				)}
				{mensagemDeErro?.length > 0 ? (
					<div className="alert alert-danger mt-2" role="alert">
						{mensagemDeErro}
					</div>
				) : null}

				<span className="block text-sm mb-3 ">
					<Link to="/login" className="text-blue-500 underline">
						Voltar para o login
					</Link>
				</span>
			</form>

			{/* Modal de Confirmação */}
			{showModal && (
				<div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
					<div className="bg-white p-6 rounded-lg shadow-lg text-center">
						<h3 className="text-lg font-semibold mb-3">Confirmação de E-mail</h3>
						<p>O e-mail informado é:</p>
						<p className="font-bold">{emailToConfirm}</p>
						<p>Por favor, confirme o e-mail para enviarmos o link para redefinir senha.</p>
						<div className="mt-4 flex justify-center space-x-4">
							<button className="btn btn-primary" onClick={confirmEmail}>
								Sim, enviar link
							</button>
							<button className="btn btn-secondary" onClick={() => setShowModal(false)}>
								Não, corrigir
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default PasswordRecovery;
